import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { BiEnvelope } from "react-icons/bi";
import { Button } from "../../components/ui/button";
import { default as Workspace } from "../../components/workspace";
import SMSForm from "./sms-form";
import SMSList from "./sms-list";

const SMSManagementPage = () => {
   const [page, setPage] = useState(1);
   const newSMSModal = useDisclosure();

   return (
      <>
         <SMSForm modal={newSMSModal} refresh={() => setPage(0)} />
         <Workspace.TopBar heading="SMS Management" />
         <Workspace.WorkspaceActions>
            <Button variant="primary" onClick={newSMSModal.onOpen}>
               <span className="inline-block text-xl me-2">
                  <BiEnvelope />
               </span>
               Compose new SMS
            </Button>
         </Workspace.WorkspaceActions>
         <Workspace.ComponentWrapper>
            <Workspace.ListContainerHeader>
               <Workspace.HeaderPadding>
                  <Workspace.ListTitleWrapper>
                     <Workspace.ListTitle>SMS History</Workspace.ListTitle>
                  </Workspace.ListTitleWrapper>
               </Workspace.HeaderPadding>
            </Workspace.ListContainerHeader>
            <SMSList page={page} setPage={setPage} />
         </Workspace.ComponentWrapper>
      </>
   );
};

export default SMSManagementPage;
